import {
  EffortMatrixSubcategory,
  ProjectMilestonesSubcategory,
  ProjectTeamGovernanceHome,
  ProjectTeamGovernanceMenu,
  TeamAssignmentSubcategory,
  TeamCapacitySubcategory,
  TeamDayOffManagementSubcategory
} from 'icons/governance'
import { FolderIcon } from 'icons/shared'
import { DateIcon } from 'icons/shared'
import {
  SupplyOmniHome,
  MySalesSubcategory,
  PaidOrdersSubcategory,
  ProductScanSubcategory,
  ProformaListSubcategory,
  ShoppingCartSubcategory,
  SupplyOmniMenu
} from 'icons/supplyOmni'
import {
  EmployeeManagementSubcategory,
  AssignTasksSubcategory,
  EmployeeStatusSubcategory,
  StoreManagementSubcategory,
  CategoryTemplateManagementSubcategory,
  ManagementTasksSubcategory,
  AssignmentVolumetryHome,
  GroupVolumetryHome,
  TasksVolumetryHome,
  EmployeeManagementHome,
  ManagementTasksHome,
  ReportsVolumetrySubcategory
} from 'icons/volumetry'

import {
  AdminMenu,
  FormatorMenu,
  RegionManagerMenu,
  StoreManagerMenu,
  TraceabilityOperatorMenu,
  BakeryMenu,
  AdminHome,
  FormatorHome,
  StoreManagerHome,
  TraceabilityOperatorHome,
  RegionManagerHome,
  UsersManagementSubcategory,
  ZonesSubcategory,
  RegionsSubcategory,
  StoresSubcategory,
  FamiliesSubcategory,
  ClustersSubcategory,
  GrowthSubcategory,
  ProductsSubcategory,
  UsageReportSubcategory,
  SalesCadentierSubcategory,
  IngredientsSubcategory,
  SalesCadentierFormatorSubcategory,
  UsageReportFormatorSubcategory,
  GrowthIndexFormatorSubcategory,
  GrowthRegionFormatorSubcategory,
  CadentierFormatorSubcategory,
  ProductGrowthIndexFormatorSubcategory,
  ProductManagementFormatorSubcategory,
  ProductManagementRegionSubcategory,
  GrowthRegionSubcategory,
  GrowthIndexSubcategory,
  CadentierSalesRegionSubcategory,
  UsageReportRegionSubcategory,
  ProductManagementSubcategory,
  CadentierStoreSubcategory,
  GrowthIndexStoreSubcategory,
  ProductGrowthIndexSubcategory,
  CadentierSalesStoreSubcategory,
  FrozenTraceabilityReportTOSubcategory,
  FrozenTraceabilityTOSubcategory,
  OwnProductionTraceabilityReportTOSubcategory,
  OwnProductionTraceabilityTOSubcategory,
  ProductManagementTOSubcategory,
  ReceivedProductsTOSubcategory,
  CarrefourLogoBlackIcon
} from 'icons/bakery'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import { createElement } from 'react'
import {
  HomeMenu,
  NotificationsMenu,
  UserMenu,
  LogoutMenu,
  UsersMenu,
  ChairMenu,
  VolumetryMenu,
  EmployeeManagementMenu,
  ManagementTasksMenu,
  ReportsVolumetryHome,
  ReportsVolumetryMenu,
  NotificationIconMenu,
  LocationIconMenu,
  IamIconMenu
} from 'icons'
import {
  AlertIconHome,
  AlertIconMenu,
  AlertIconSubcategory,
  OutOfShelfMenu
} from 'icons/outOfShelf'
import LocationManagementMenu from 'icons/location/LocationManagementMenu'
import LocationManagementSubcategory from 'icons/location/LocationManagementSubcategory'
import LocationManagementHome from 'icons/location/LocationManagementHome'
import ManagementAlertsSubcategory from 'icons/outOfShelf/submodules/ManagementAlertsSubcategory'
import IamJobsIconMenu from 'icons/iam/IamJobsIconMenu'
import IamJobsIconHome from 'icons/iam/IamJobsIconHome'
import IamPartnersIconMenu from 'icons/iam/IamPartnersIconMenu'
import IamPartnersIconHome from 'icons/iam/IamPartnersIconHome'
import IamJobsIconSubcategory from 'icons/iam/IamJobsIconSubcategory'
import IamPartnersIconSubcategory from 'icons/iam/IamPartnersIconSubcategory'
import IamManagersIconSubcategory from 'icons/iam/IamManagersIconSubcategory'
import IamDelegatesIconSubcategory from 'icons/iam/IamDelegatesIconSubcategory'
import IamJobsCatIconSubcategory from 'icons/iam/IamJobsCatIconSubcategory'
import IamUndefinedJobsIconSubcategory from 'icons/iam/IamUndefinedJobsIconSubcategory'
import {
  ShopReceptionAdminMenu,
  AdminIconHome,
  AdminIconMenu,
  ShopReceptionAdminIconHome,
  ShopReceptionAdminIconMenu,
  PackagingIconMenu,
  PackagingIconHome,
  HistoricalReportsIconHome,
  HistoricalReportsIconMenu,
  DepositAdminIconSubcategory,
  HubAdminIconSubcategory,
  ShopAdminIconSubcategory,
  RegionAdminIconSubcategory,
  CentrilzeAdminIconSubcategory,
  ScannerTypeAdminIconSubcategory,
  SubfamilyValidityTresholdIconSubcategory,
  MetiProductsIconSubcategory,
  PackingTypeAdminIconSubcategory,
  ShortDlcProductsIconSubcategory,
  InfologReceptionFilesIconSubcategory,
  SensitiveProductsIconSubcategory,
  SgrProductsIconSubcategory,
  ParentSocietyListIconSubcategory,
  NoticeSeriesNumberListIconSubcategory,
  DeliveryTicketIconSubcategory,
  TruckListIconSubcategory,
  WrongDestinationSupportIconSubcategory,
  NotOrderedProductsIconSubcategory,
  MetiFilesIconSubcategory,
  ProductsWithDifferencesIconSubcategory,
  SupportTraceabilityIconSubcategory,
  DeliveryTruckReportIconSubcategory,
  TrucksReturnIconSubcategory,
  PackageRollIconSubcategory,
  PackageBalanceIconSubcategory,
  PackageInventoryIconSubcategory,
  StoreReturnsDisputesIconSubcategory,
  PackageTypesDifferencesIconSubcategory,
  ReturnedPackageIconSubcategory,
  PackageComplianceIconSubcategory,
  PackageTimerDisputesIconSubcategory,
  CentralizedNoticeIconSubcategory,
  TransportResponsibleIconSubcategory
} from 'icons/shop-reception/admin'
import {
  ShopReceptionMobileMenu,
  ShopReceptionMobileIconMenu,
  ShopReceptionMobileIconHome,
  ShopReturnMobileIconHome,
  ShopReturnMobileIconMenu,
  ShopReceptionMobileHubIconHome,
  ShopReceptionMobileHubIconMenu,
  ShopReturnMobileHubIconHome,
  ShopReturnMobileHubIconMenu,
  ShopReturnMobileWarehouseIconHome,
  ShopReturnMobileWarehouseIconMenu,
  PackageInventoryUpdateIconHome,
  PackageInventoryUpdateIconMenu,
  ProcessingReceptionIconSubcategory,
  RegisterReturnIconSubcategory,
  ContinueReturnIconSubcategory,
  ExpectedTrucksIconSubcategory,
  ProcessingShipmentnIconSubcategory,
  ShippedTrucksIconSubcategory,
  ExpectedReturnsIconSubcategory,
  InProgressReturnReceptionIconSubcategory,
  PackageInventoryUpdateIconSubcategory,
  DeliveryValidateIconSubcategory,
  ReturoIconHome,
  ReturoIconMenu,
  SealScanSubcategory,
  InProgressSealsSubcategory,
  AddReportSubcategory,
  ReportProcessingSubcategory
} from 'icons/shop-reception/mobile'
import {
  WasteManagementAccompanyNoteReportSubcategory,
  WasteManagementAccompanyNoteSubcategory,
  WasteManagementAdminHome,
  WasteManagementAdminMenu,
  WasteManagementCollectorReportReportSubcategory,
  WasteManagementCollectorReportSubcategory,
  WasteManagementCompaniesSubcategory,
  WasteManagementDailyReportReportSubcategory,
  WasteManagementDailyReportSubcategory,
  WasteManagementExternalArticlesReportSubcategory,
  WasteManagementIconMenu,
  WasteManagementRecordsHome,
  WasteManagementRecordsMenu,
  WasteManagementReportsHome,
  WasteManagementReportsMenu,
  WasteManagementExternalArticlesReportReportSubcategory,
  WasteManagementNoDailyReportsReportSubcategory
} from 'icons/waste-management'
import {
  EmployeeManagementIconMenu,
  EmployeeModuleHome,
  EmployeeModuleMenu,
  EmployeeModuleSubcategory
} from 'icons/employee'
import {
  CoraSGRIconMenu,
  CoraSGRModuleHome,
  CoraSGRModuleMenu,
  CoraSGRModuleSubcategory
} from 'icons/cora-sgr-coupons'
import IamAssignmentsIconSubcategory from 'icons/iam/IamAssignmentsIconSubcategory'
import IamLegalEntitiesIconSubcategory from 'icons/iam/IamLegalEntitiesIconSubcategory'
import IamStoresIconSubcategory from 'icons/iam/IamStoresIconSubcategory'
import {
  EmployeeDiscountIconMenu,
  EmployeeDiscountModuleHome,
  EmployeeDiscountModuleMenu,
  EmployeeDiscountReportSubcategory,
  EmployeeDiscountRuleManagementSubcategory,
  EmployeeDiscountRulesSubcategory
} from 'icons/employee-discount'

const IconComponents = {
  // Shared
  FolderIcon,
  DateIcon,
  // Governance
  ProjectTeamGovernanceHome,
  ProjectTeamGovernanceMenu,
  TeamDayOffManagementSubcategory,
  TeamAssignmentSubcategory,
  TeamCapacitySubcategory,
  ProjectMilestonesSubcategory,
  EffortMatrixSubcategory,
  // SupplyOmni
  SupplyOmniHome,
  SupplyOmniMenu,
  ProductScanSubcategory,
  ProformaListSubcategory,
  MySalesSubcategory,
  ShoppingCartSubcategory,
  PaidOrdersSubcategory,
  // Volumetry
  EmployeeManagementSubcategory,
  ManagementTasksSubcategory,
  AssignTasksSubcategory,
  EmployeeStatusSubcategory,
  StoreManagementSubcategory,
  CategoryTemplateManagementSubcategory,
  AssignmentVolumetryHome,
  GroupVolumetryHome,
  TasksVolumetryHome,
  EmployeeManagementHome,
  ManagementTasksHome,
  ReportsVolumetryHome,
  ReportsVolumetrySubcategory,
  ReportsVolumetryMenu,
  // Menu
  BakeryMenu,
  HomeMenu,
  NotificationsMenu,
  UserMenu,
  LogoutMenu,
  UsersMenu,
  ChairMenu,
  VolumetryMenu,
  EmployeeManagementMenu,
  ManagementTasksMenu,
  LocationIconMenu,
  IamIconMenu,
  // Bakery
  //home
  AdminHome,
  FormatorHome,
  StoreManagerHome,
  TraceabilityOperatorHome,
  RegionManagerHome,
  //menu
  AdminMenu,
  FormatorMenu,
  RegionManagerMenu,
  StoreManagerMenu,
  TraceabilityOperatorMenu,
  NotificationIconMenu,
  //admin
  UsersManagementSubcategory,
  ZonesSubcategory,
  RegionsSubcategory,
  StoresSubcategory,
  FamiliesSubcategory,
  ClustersSubcategory,
  GrowthSubcategory,
  ProductsSubcategory,
  UsageReportSubcategory,
  SalesCadentierSubcategory,
  IngredientsSubcategory,
  //formator
  SalesCadentierFormatorSubcategory,
  UsageReportFormatorSubcategory,
  GrowthIndexFormatorSubcategory,
  GrowthRegionFormatorSubcategory,
  CadentierFormatorSubcategory,
  ProductGrowthIndexFormatorSubcategory,
  ProductManagementFormatorSubcategory,
  //regionMg
  ProductManagementRegionSubcategory,
  GrowthRegionSubcategory,
  GrowthIndexSubcategory,
  CadentierSalesRegionSubcategory,
  UsageReportRegionSubcategory,
  //storeMg
  ProductManagementSubcategory,
  CadentierStoreSubcategory,
  GrowthIndexStoreSubcategory,
  ProductGrowthIndexSubcategory,
  CadentierSalesStoreSubcategory,
  //traceabilityOp
  FrozenTraceabilityReportTOSubcategory,
  FrozenTraceabilityTOSubcategory,
  OwnProductionTraceabilityReportTOSubcategory,
  OwnProductionTraceabilityTOSubcategory,
  ProductManagementTOSubcategory,
  ReceivedProductsTOSubcategory,
  CarrefourLogoBlackIcon,
  // out of shelf
  AlertIconHome,
  AlertIconMenu,
  AlertIconSubcategory,
  ManagementAlertsSubcategory,
  OutOfShelfMenu,
  // location management
  LocationManagementHome,
  LocationManagementSubcategory,
  LocationManagementMenu,
  // shop reception admin
  ShopReceptionAdminMenu,
  AdminIconHome,
  AdminIconMenu,
  ShopReceptionAdminIconHome,
  ShopReceptionAdminIconMenu,
  PackagingIconHome,
  PackagingIconMenu,
  HistoricalReportsIconHome,
  HistoricalReportsIconMenu,
  DepositAdminIconSubcategory,
  HubAdminIconSubcategory,
  ShopAdminIconSubcategory,
  RegionAdminIconSubcategory,
  CentrilzeAdminIconSubcategory,
  ScannerTypeAdminIconSubcategory,
  SubfamilyValidityTresholdIconSubcategory,
  MetiProductsIconSubcategory,
  SensitiveProductsIconSubcategory,
  PackingTypeAdminIconSubcategory,
  ShortDlcProductsIconSubcategory,
  InfologReceptionFilesIconSubcategory,
  SgrProductsIconSubcategory,
  ParentSocietyListIconSubcategory,
  NoticeSeriesNumberListIconSubcategory,
  DeliveryTicketIconSubcategory,
  TruckListIconSubcategory,
  WrongDestinationSupportIconSubcategory,
  NotOrderedProductsIconSubcategory,
  MetiFilesIconSubcategory,
  ProductsWithDifferencesIconSubcategory,
  SupportTraceabilityIconSubcategory,
  DeliveryTruckReportIconSubcategory,
  TrucksReturnIconSubcategory,
  PackageRollIconSubcategory,
  PackageBalanceIconSubcategory,
  PackageInventoryIconSubcategory,
  StoreReturnsDisputesIconSubcategory,
  PackageTypesDifferencesIconSubcategory,
  ReturnedPackageIconSubcategory,
  PackageComplianceIconSubcategory,
  PackageTimerDisputesIconSubcategory,
  CentralizedNoticeIconSubcategory,
  TransportResponsibleIconSubcategory,
  // shop reception mobile
  ShopReceptionMobileMenu,
  ShopReceptionMobileIconHome,
  ShopReceptionMobileIconMenu,
  ShopReturnMobileIconHome,
  ShopReturnMobileIconMenu,
  ShopReceptionMobileHubIconHome,
  ShopReceptionMobileHubIconMenu,
  ShopReturnMobileHubIconHome,
  ShopReturnMobileHubIconMenu,
  ShopReturnMobileWarehouseIconHome,
  ShopReturnMobileWarehouseIconMenu,
  PackageInventoryUpdateIconHome,
  PackageInventoryUpdateIconMenu,
  ProcessingReceptionIconSubcategory,
  RegisterReturnIconSubcategory,
  ContinueReturnIconSubcategory,
  ExpectedTrucksIconSubcategory,
  ProcessingShipmentnIconSubcategory,
  ShippedTrucksIconSubcategory,
  ExpectedReturnsIconSubcategory,
  InProgressReturnReceptionIconSubcategory,
  PackageInventoryUpdateIconSubcategory,
  DeliveryValidateIconSubcategory,
  ReturoIconHome,
  ReturoIconMenu,
  SealScanSubcategory,
  InProgressSealsSubcategory,
  AddReportSubcategory,
  ReportProcessingSubcategory,
  // waste management
  WasteManagementAdminHome,
  WasteManagementRecordsHome,
  WasteManagementDailyReportSubcategory,
  WasteManagementCompaniesSubcategory,
  WasteManagementCollectorReportSubcategory,
  WasteManagementExternalArticlesReportSubcategory,
  WasteManagementIconMenu,
  WasteManagementAdminMenu,
  WasteManagementRecordsMenu,
  WasteManagementAccompanyNoteSubcategory,
  WasteManagementReportsHome,
  WasteManagementReportsMenu,
  WasteManagementAccompanyNoteReportSubcategory,
  WasteManagementCollectorReportReportSubcategory,
  WasteManagementDailyReportReportSubcategory,
  WasteManagementExternalArticlesReportReportSubcategory,
  WasteManagementNoDailyReportsReportSubcategory,
  // IAM
  IamJobsIconMenu,
  IamJobsIconHome,
  IamJobsIconSubcategory,
  IamPartnersIconMenu,
  IamPartnersIconHome,
  IamPartnersIconSubcategory,
  IamManagersIconSubcategory,
  IamDelegatesIconSubcategory,
  IamJobsCatIconSubcategory,
  IamUndefinedJobsIconSubcategory,
  IamAssignmentsIconSubcategory,
  IamLegalEntitiesIconSubcategory,
  IamStoresIconSubcategory,
  // employee management
  EmployeeManagementIconMenu,
  EmployeeModuleHome,
  EmployeeModuleMenu,
  EmployeeModuleSubcategory,
  // Cora SGR
  CoraSGRIconMenu,
  CoraSGRModuleMenu,
  CoraSGRModuleHome,
  CoraSGRModuleSubcategory,
  // Employee Discount
  EmployeeDiscountIconMenu,
  EmployeeDiscountModuleMenu,
  EmployeeDiscountModuleHome,
  EmployeeDiscountReportSubcategory,
  EmployeeDiscountRulesSubcategory,
  EmployeeDiscountRuleManagementSubcategory
}

export type IconType = 'Menu' | 'Home' | 'Subcategory' | 'Icon'

interface IconProps {
  iconName: string
  iconType: IconType
}

const Icon_v2: React.FC<IconProps> = ({ iconName, iconType }) => {
  const iconComponent = IconComponents[`${iconName}${iconType}`]
  return iconComponent ? createElement(iconComponent) : <CheckBoxOutlineBlankIcon />
}

export default Icon_v2
